export const faBedAlt = {
  prefix: "fas",
  iconName: "bed-alt",
  icon: [
    24,
    24,
    [],
    null,
    "M5,3 C3.895,3 3,3.895 3,5 L3,9 C3,9.552 3.448,10 4,10 C4.552,10 5,9.552 5,9 L5,8 C5,7.448 5.448,7 6,7 L10,7 C10.552,7 11,7.448 11,8 L11,9 C11,9.552 11.448,10 12,10 C12.552,10 13,9.552 13,9 L13,8 C13,7.448 13.448,7 14,7 L18,7 C18.552,7 19,7.448 19,8 L19,9 C19,9.552 19.448,10 20,10 C20.552,10 21,9.552 21,9 L21,5 C21,3.895 20.105,3 19,3 L5,3 Z M4,12 C2.895,12 2,12.895 2,14 L2,20 C2,20.552 2.448,21 3,21 C3.552,21 4,20.552 4,20 L4,19 L20,19 L20,20 C20,20.552 20.448,21 21,21 C21.552,21 22,20.552 22,20 L22,14 C22,12.895 21.105,12 20,12 L4,12 Z"
  ]
};

export const faBluePrint = {
  prefix: "fas",
  iconName: "blue-print",
  icon: [
    24,
    24,
    [],
    null,
    "M9.78,4.22V9.78H8.67V4.22H4.22v8.89H8.67V12H9.78v5.56H8.67V14.22H4.22v5.56H12V17.56h1.11v2.22h6.67V17.56H22V22H2V2H22V15.33H19.78V9.78H13.11v5.56H12V8.67h7.78V4.22Z"
  ]
};

export const faEmbed = {
  prefix: "fas",
  iconName: "embed",
  icon: [
    24,
    24,
    [],
    null,
    "M4,2 C2.9,2 2,2.9 2,4 L2,19 C2,20.1 2.9,21 4,21 L9.101562,21 C9.035563,20.674 9,20.34 9,20 C9,18.663 9.520844,17.406891 10.464844,16.462891 L15.464844,11.462891 C16.183844,10.743891 17.071,10.293469 18,10.105469 L18,8.828125 C18,8.298125 17.789062,7.7890625 17.414062,7.4140625 L12.585938,2.5859375 C12.210937,2.2109375 11.701875,2 11.171875,2 L4,2 Z M11,3.5 L16.5,9 L12,9 C11.448,9 11,8.552 11,8 L11,3.5 Z M19.183594,12.005859 C18.939484,11.991297 18.68875,12.005281 18.4375,12.050781 C17.8115,12.163781 17.250781,12.507031 16.800781,12.957031 L16.169922,13.587891 C15.779922,13.977891 15.779922,14.611953 16.169922,15.001953 C16.559922,15.391953 17.192031,15.391953 17.582031,15.001953 L18.292969,14.292969 C18.481969,14.103969 18.732,14 19,14 C19.267,14 19.518031,14.103969 19.707031,14.292969 C20.086031,14.670969 20.085031,15.329031 19.707031,15.707031 L18.998047,16.416016 C18.608047,16.806016 18.608047,17.440078 18.998047,17.830078 C19.388047,18.220078 20.022109,18.220078 20.412109,17.830078 L21.042969,17.199219 C21.492969,16.750219 21.835219,16.189453 21.949219,15.564453 C22.131219,14.559453 21.820094,13.575906 21.121094,12.878906 C20.597594,12.355406 19.915922,12.049547 19.183594,12.005859 Z M17,16 C16.744,16 16.487969,16.097969 16.292969,16.292969 L15.292969,17.292969 C14.902969,17.682969 14.902969,18.317031 15.292969,18.707031 C15.682969,19.097031 16.317031,19.097031 16.707031,18.707031 L17.707031,17.707031 C18.098031,17.316031 18.098031,16.682969 17.707031,16.292969 C17.512031,16.097969 17.256,16 17,16 Z M13.294922,16.876953 C13.038922,16.876953 12.782891,16.974922 12.587891,17.169922 L11.957031,17.800781 C11.508031,18.249781 11.163781,18.8115 11.050781,19.4375 C10.868781,20.4425 11.180906,21.423094 11.878906,22.121094 C12.576906,22.820094 13.560453,23.131219 14.564453,22.949219 C15.189453,22.835219 15.750219,22.492969 16.199219,22.042969 L16.830078,21.412109 C17.220078,21.022109 17.220078,20.388047 16.830078,19.998047 C16.440078,19.608047 15.806016,19.608047 15.416016,19.998047 L14.707031,20.707031 C14.329031,21.085031 13.670969,21.086031 13.292969,20.707031 C13.103969,20.518031 13,20.267 13,20 C13,19.732 13.103969,19.481969 13.292969,19.292969 L14.001953,18.582031 C14.391953,18.192031 14.391953,17.559922 14.001953,17.169922 C13.806953,16.974922 13.550922,16.876953 13.294922,16.876953 Z"
  ]
};

export const faFacebook = {
  prefix: "fas",
  iconName: "facebook",
  icon: [
    24,
    24,
    [],
    null,
    "M21.8181818,0 L2.18181818,0 C0.976363636,0 0,0.976363636 0,2.18181818 L0,21.8181818 C0,23.0236364 0.976363636,24 2.18181818,24 L13.0909091,24 L13.0909091,14.1818182 L9.81818182,14.1818182 L9.81818182,10.9090909 L13.0909091,10.9090909 L13.0909091,9.15163636 C13.0909091,5.82436364 14.712,4.36363636 17.4774545,4.36363636 C18.8018182,4.36363636 19.5021818,4.46181818 19.8338182,4.50654545 L19.8338182,7.63636364 L17.9476364,7.63636364 C16.7738182,7.63636364 16.3636364,8.256 16.3636364,9.51054545 L16.3636364,10.9090909 L19.8043636,10.9090909 L19.3374545,14.1818182 L16.3636364,14.1818182 L16.3636364,24 L21.8181818,24 C23.0236364,24 24,23.0236364 24,21.8181818 L24,2.18181818 C24,0.976363636 23.0225455,0 21.8181818,0 Z"
  ]
};

export const faLandDimensions = {
  prefix: "fas",
  iconName: "land-dimensions",
  icon: [
    24,
    24,
    [],
    null,
    "M3,5 L3,21 L9,21 L9,19.5 L7,19.5 L7,18 L9,18 L9,16.5 L5,16.5 L5,15 L9,15 L9,13.5 L7,13.5 L7,12 L9,12 L9,10.5 L5,10.5 L5,9 L9,9 L9,5 L10.5,5 L10.5,9 L12,9 L12,7 L13.5,7 L13.5,9 L15,9 L15,5 L16.5,5 L16.5,9 L18,9 L18,7 L19.5,7 L19.5,9 L21,9 L21,3 L5,3 C3.8954305,3 3,3.8954305 3,5 M6,7 C5.44771525,7 5,6.55228475 5,6 C5,5.44771525 5.44771525,5 6,5 C6.55228475,5 7,5.44771525 7,6 C7,6.55228475 6.55228475,7 6,7 Z"
  ]
};

export const faOffice = {
  prefix: "fas",
  iconName: "office",
  icon: [
    24,
    24,
    [],
    null,
    "M4,3 C2.8954305,3 2,3.8954305 2,5 C2,6.1045695 2.8954305,7 4,7 C5.1045695,7 6,6.1045695 6,5 C6,3.8954305 5.1045695,3 4,3 Z M12,3 C10.8954305,3 10,3.8954305 10,5 C10,6.1045695 10.8954305,7 12,7 C13.1045695,7 14,6.1045695 14,5 C14,3.8954305 13.1045695,3 12,3 Z M20,3 C18.8954305,3 18,3.8954305 18,5 C18,6.1045695 18.8954305,7 20,7 C21.1045695,7 22,6.1045695 22,5 C22,3.8954305 21.1045695,3 20,3 Z M4,8 C2.895,8 2,8.895 2,10 L2,16 C2,17.105 2.895,18 4,18 L7,18 L7,20 C7,20.552 7.448,21 8,21 C8.552,21 9,20.552 9,20 L9,17 C9,16.448 8.552,16 8,16 C7.448,16 7,15.552 7,15 C7,14.448 7.448,14 8,14 L16,14 C16.552,14 17,14.448 17,15 C17,15.552 16.552,16 16,16 C15.448,16 15,16.448 15,17 L15,20 C15,20.552 15.448,21 16,21 C16.552,21 17,20.552 17,20 L17,18 L20,18 C21.105,18 22,17.105 22,16 L22,10 C22,8.895 21.105,8 20,8 L19,8 C17.895,8 17,8.895 17,10 L17,12 L15,12 L15,10 C15,8.895 14.105,8 13,8 L11,8 C9.895,8 9,8.895 9,10 L9,12 L7,12 L7,10 C7,8.895 6.105,8 5,8 L4,8 Z"
  ]
};

export const faPortfolio = {
  prefix: "fas",
  iconName: "portfolio",
  icon: [
    24,
    24,
    [],
    null,
    "M10,2.99990778 C9.73243065,2.9963686 9.47456604,3.10011692 9.2840682,3.28804542 C9.09357037,3.47597391 8.98633022,3.73240601 8.9863281,4 L4,4 C2.895,4 2,4.895 2,6 L2,12 C2,13.103 2.897,14 4,14 L20,14 C21.103,14 22,13.103 22,12 L22,6 C22,4.895 21.105,4 20,4 L15.013672,4 C15.0136699,3.73240599 14.9064297,3.47597388 14.7159319,3.28804538 C14.525434,3.10011688 14.2675694,2.99636858 14,2.99990778 L10,2.99990778 Z M12,10 C12.552,10 13,10.448 13,11 C13,11.552 12.552,12 12,12 C11.448,12 11,11.552 11,11 C11,10.448 11.448,10 12,10 Z M2,15.443359 L2,18 C2,19.105 2.895,20 4,20 L20,20 C21.105,20 22,19.105 22,18 L22,15.443359 C21.409,15.787359 20.732,16 20,16 L4,16 C3.268,16 2.591,15.787359 2,15.443359 Z"
  ]
};

export const faPrinter = {
  prefix: "fas",
  iconName: "printer",
  icon: [
    24,
    24,
    [],
    null,
    "M7,3 C6.448,3 6,3.448 6,4 L6,6 C6,6.552 6.448,7 7,7 L17,7 C17.552,7 18,6.552 18,6 L18,4 C18,3.448 17.552,3 17,3 L7,3 Z M5,9 C3.35,9 2,10.35 2,12 L2,16 C2,17.105 2.895,18 4,18 L6,18 L6,20 C6,21.105 6.895,22 8,22 L16,22 C17.105,22 18,21.105 18,20 L18,18 L20,18 C21.105,18 22,17.105 22,16 L22,12 C22,10.35 20.65,9 19,9 L5,9 Z M19,11 C19.6,11 20,11.4 20,12 C20,12.6 19.6,13 19,13 C18.4,13 18,12.6 18,12 C18,11.4 18.4,11 19,11 Z M8.5,15 L15.5,15 C15.776,15 16,15.224 16,15.5 L16,19.5 C16,19.776 15.776,20 15.5,20 L8.5,20 C8.224,20 8,19.776 8,19.5 L8,15.5 C8,15.224 8.224,15 8.5,15 Z"
  ]
};

export const faSecurityCamera = {
  prefix: "fas",
  iconName: "security-camera",
  icon: [
    24,
    24,
    [],
    null,
    "M18.15,4.00564469 C17.77,3.97564469 17.37,4.06564469 17,4.26564469 L8.35,9.26564469 C7.39,9.82564469 7.07,11.0656447 7.62,12.0056447 L9.12,14.5956447 C9.67,15.5656447 10.89,15.8856447 11.85,15.3356447 L13.65,14.2956447 C13.92,14.7556447 14.32,15.1256447 14.81,15.3356447 L14.81,17.1056447 C14.81,18.1956447 15.7,19.0656447 16.81,19.0656447 L22,19.0656447 L22,17.1056447 L16.81,17.1056447 L16.81,15.3356447 C17.72,14.9356447 18.31,14.0356447 18.31,13.0656447 C18.31,12.6056447 18.19,12.1756447 17.97,11.7956447 L20.5,10.3356447 C21.47,9.77564469 21.8,8.56564469 21.24,7.59564469 L19.74,5.00564469 C19.4,4.40564469 18.79,4.06564469 18.15,4.00564469 M6.22,12.2356447 L2,12.9356447 L2.75,14.2356447 L4.75,17.6956447 L5.5,18.9956447 L8.22,15.6956447 L6.22,12.2356447 Z"
  ]
};

export const faShower = {
  prefix: "fas",
  iconName: "shower",
  icon: [
    24,
    24,
    [],
    null,
    "M11,3 C9.9069372,3 9,3.9069372 9,5 L9,10 L2,10 C1.447,10 1,10.447 1,11 C1,11.553 1.447,12 2,12 L2.1171875,12 L2.5703125,15.619141 C2.7405039,16.981217 3.4638955,18.146793 4.484375,18.9375 L4.0292969,20.757812 C3.8722969,21.388812 4.35,22 5,22 C5.459,22 5.85775,21.687188 5.96875,21.242188 L6.3203125,19.832031 C6.7109161,19.930341 7.1128502,20 7.53125,20 L16.46875,20 C16.887316,20 17.289014,19.930341 17.679688,19.832031 L18.03125,21.242188 C18.14225,21.687188 18.541,22 19,22 C19.65,22 20.127703,21.388812 19.970703,20.757812 L19.515625,18.939453 C20.536909,18.148739 21.259401,16.981976 21.429688,15.619141 L21.884766,12 L22,12 C22.553,12 23,11.553 23,11 C23,10.447 22.553,10 22,10 L11,10 L11,5 L14,5 L14,6 C13.448,6 13,6.448 13,7 C13,7.552 13.448,8 14,8 L14.832031,8 C14.9400224,8.01784905 15.0502116,8.01784905 15.158203,8 L16,8 C16.552,8 17,7.552 17,7 C17,6.448 16.552,6 16,6 L16,5 C16,3.9069372 15.093063,3 14,3 L11,3 Z"
  ]
};

export const faWhatsapp = {
  prefix: "fas",
  iconName: "whatsapp",
  icon: [
    24,
    24,
    [],
    null,
    "M19.077,4.928 C16.995,2.845 14.155,1.794 11.173,2.034 C7.164,2.356 3.65,5.144 2.474,8.99 C1.634,11.738 1.987,14.607 3.355,16.977 L2.059,21.28 C1.935,21.693 2.312,22.082 2.729,21.971 L7.233,20.764 C8.692,21.56 10.334,21.979 12.006,21.98 L12.01,21.98 C16.205,21.98 20.081,19.414 21.422,15.439 C22.728,11.563 21.762,7.616 19.077,4.928 Z M16.898,15.554 C16.69,16.137 15.671,16.699 15.213,16.74 C14.755,16.782 14.326,16.947 12.218,16.116 C9.681,15.116 8.079,12.515 7.955,12.349 C7.83,12.182 6.936,10.996 6.936,9.768 C6.936,8.54 7.581,7.936 7.81,7.687 C8.039,7.437 8.309,7.375 8.476,7.375 C8.642,7.375 8.809,7.375 8.954,7.381 C9.132,7.388 9.329,7.397 9.516,7.812 C9.738,8.306 10.223,9.54 10.285,9.665 C10.347,9.79 10.389,9.936 10.306,10.102 C10.223,10.268 10.181,10.372 10.057,10.518 C9.932,10.664 9.795,10.843 9.683,10.955 C9.558,11.079 9.428,11.215 9.573,11.464 C9.719,11.714 10.219,12.531 10.961,13.192 C11.915,14.042 12.718,14.305 12.968,14.431 C13.218,14.556 13.363,14.535 13.509,14.368 C13.655,14.202 14.133,13.64 14.299,13.39 C14.465,13.14 14.632,13.182 14.861,13.265 C15.09,13.348 16.317,13.952 16.566,14.077 C16.816,14.202 16.982,14.264 17.044,14.368 C17.106,14.471 17.106,14.971 16.898,15.554 Z"
  ]
};

export const faTwitterX = {
  prefix: "fas",
  iconName: "twitter-x",
  icon: [
    24,
    24,
    [],
    null,
    "M17.1761 4H19.9362L13.9061 10.7774L21 20H15.4456L11.0866 14.4717L6.11722 20H3.35544L9.76722 12.7935L3 4H8.69444L12.6741 9.06378L17.1761 4ZM16.1399 18.32H17.5899L7.92889 5.57333H6.37889L16.1399 18.32Z"
  ]
};
